import { render, staticRenderFns } from "./LimitlessButton.vue?vue&type=template&id=38d36902&scoped=true&"
import script from "./LimitlessButton.vue?vue&type=script&lang=js&"
export * from "./LimitlessButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d36902",
  null
  
)

export default component.exports